module.exports = __webpack_public_path__ + "img/extra-logo-white.0c55ff0.svg";